import type { NotificationPlacement } from 'antd/es/notification/interface';
import { notification } from 'antd';

export type Location = {
  uuid: string;
  locationName: string;
  locationType: string;
};

export const sortLocationsByName = (locations: Location[]): Location[] => {
  return [...locations].sort((a, b) =>
    a.locationName.localeCompare(b.locationName),
  );
};

export const filterLocationsBySearch = (
  locations: Location[],
  searchTerm: string,
): Location[] => {
  const value = searchTerm.toLowerCase();
  return locations.filter((location) =>
    location.locationName.toLowerCase().includes(value),
  );
};

export const showUncheckLocationError = (placement: NotificationPlacement) => {
  notification.info({
    message: 'This location cannot be unselected',
    description:
      'In order to remove this location from the dependency chain, please make the dependency 0% on the next page and return to this screen to uncheck it.',
    placement,
    duration: 10,
    type: 'error',
  });
};
